export const EMAIL = process.env.GATSBY_LOCALE === 'en-US' ? 'hello@mantl.co' : 'contact@mantlmen.co.uk'